import { CanActivate, ActivatedRouteSnapshot, RouterStateSnapshot } from '@angular/router';
import { UrlBuilder } from '../core/url-builder/url-builder';
import { Injectable } from '@angular/core';
import { first, map } from 'rxjs/operators';
import { UserStorage } from '../user/user-storage';
import { ReportsStorageService } from './reports/services/reports-storage-service';
import { SampleMonitoringStorage } from './sample-monitoring/service/sample-monitoring-storage';

@Injectable()
export class SampleTrackingGuard implements CanActivate {

    constructor(private userStorage: UserStorage, private urlBuilder: UrlBuilder, private reportsStorage: ReportsStorageService, private monitoringStorage: SampleMonitoringStorage) {
    }

    public async canActivate(route: ActivatedRouteSnapshot, state: RouterStateSnapshot) {

        const user = await this.userStorage.currentUser
            .pipe(first())
            .toPromise();
        if (!user.isSponsor) {
            this.urlBuilder.esa().navigate();
            return false;
        }
        this.reportsStorage.forceLoadReportCount();
        this.monitoringStorage.forceLoadNotificationCount();
        return true;
    }
}